import HelperPlatform from 'utils/helper-platform'
import HelperAlerts from 'utils/HelperAlerts'
import i18n from 'utils/i18n'
import * as ImageManipulator from 'expo-image-manipulator'
import * as ImagePicker from 'expo-image-picker'
import React, { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import Button from "theme/Button";
import _ from 'lodash'
import LoadingComponent from 'components/atoms/Loading'
import RemoteImage from 'components/atoms/RemoteImage'


const ThemedImagePicker = ({ source, loading = false, onSelect }) => {
	const [image, setImage] = useState( null );
	
	const viewImage = image !== null ? image : source;
	
	const getPermissionAsync = async ( ) => {
		if ( HelperPlatform.isNotWeb() ) {
			const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
			
			if (status !== 'granted') {
				HelperAlerts.alert(
					i18n.t('page.profile.no_roll_permission')
				);
			} else {
				await pickImage();
			}
		} else {
			await pickImage();
		}
	};
	
	const pickImage = async () => {
		try {
			const result = await ImagePicker.launchImageLibraryAsync( {
				mediaTypes: ImagePicker.MediaTypeOptions.Images,
				allowsEditing: true,
				aspect: [ 1, 1 ],
				quality: 1,
				exif: false
			} );
			
			if ( !result.cancelled ) {
				// Resize the image
				const manipResult = await ImageManipulator.manipulateAsync(
					result.uri,
					[
						{
							resize: {
								width: 1000
							}
						}
					],
					{
						compress: 0.8,
						format: ImageManipulator.SaveFormat.JPEG,
						base64: true
					}
				);
				
				if( _.isFunction( onSelect ) ) {
					onSelect({
						base64: manipResult.base64
					})
				}
				
				return manipResult.base64
			}
		} catch (error) {}
		
		return null;
	};
	
	let loadingView = null;
	if( loading ) {
		loadingView = (
			<LoadingComponent
				containerStyle={ staticStyles.loadingComponentPositionAbsolute }
			/>
		)
	}
	
	let imageView = null
	if( viewImage ) {
		imageView = (
			<RemoteImage
				uri={ viewImage }
				desiredWidth={ 200 }
			/>
		)
	}
	
	return (
		<View
			style={ staticStyles.viewFlex1AlignItemsCenter }>
			{ imageView }
			
			{ loadingView }
			
			<Button
				style={ staticStyles.buttonMarginTop12 }
				onPress={ getPermissionAsync }>
				
				{ i18n.t('basic.choose_image') }
			</Button>
		</View>
	)
}

const staticStyles = StyleSheet.create({
	loadingComponentPositionAbsolute: {
		position: 'absolute',
	},
	viewFlex1AlignItemsCenter: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
	},
	buttonMarginTop12: {
		marginTop: 12,
	},
});

export default ThemedImagePicker
